import { Injectable } from '@jkhy/frontend-utils/di';
import {
    LookupModelDto,
    OfxTransactionTypeModelDto,
    TransactionCodeGroupModelDto,
    TransactionCodeGroupsClient,
    TransactionCodesClient,
} from '@treasury/api/bo';
import { TransactionCodeGroup } from './entities/transaction-code-group.entity';
import { TransactionCode } from './entities/transaction-code.entity';

@Injectable()
export class TransactionCodesService {
    constructor(
        private readonly transactionCodesClient: TransactionCodesClient,
        private readonly transactionCodeGroupsClient: TransactionCodeGroupsClient
    ) {}

    public async getTransactionCodes(): Promise<TransactionCode[]> {
        const response = await this.transactionCodesClient.transactionCodesGet();
        return (response.data ?? []).map(TransactionCode.from);
    }

    public async updateTransactionCode(
        id: number,
        transactionCode: TransactionCode
    ): Promise<TransactionCode> {
        const response = await this.transactionCodesClient.transactionCodesPut(
            id,
            transactionCode.toDto()
        );
        return TransactionCode.from(response.data);
    }

    public async getTransactionCodeSyncDetails(): Promise<TransactionCode[]> {
        const response = await this.transactionCodesClient.transactionCodesSyncDetails();
        return (response.data ?? []).map(TransactionCode.from);
    }

    public async syncTransactionCodes(): Promise<void> {
        await this.transactionCodesClient.transactionCodesSync();
    }

    public async cloneTransactionCode(id: number, targetCodes: LookupModelDto[]): Promise<void> {
        await this.transactionCodesClient.transactionCodesClone(id, targetCodes);
    }

    public async getOfxTransactionTypes(): Promise<OfxTransactionTypeModelDto[]> {
        const response = await this.transactionCodesClient.transactionCodesGetOfxTransactionTypes();
        return response.data ?? [];
    }

    public async getTransactionCodeGroups(): Promise<TransactionCodeGroup[]> {
        const response = await this.transactionCodeGroupsClient.transactionCodeGroupsGet();
        return (response.data ?? []).map(TransactionCodeGroup.from);
    }

    public async createTransactionCodeGroup(
        group: TransactionCodeGroup
    ): Promise<TransactionCodeGroup> {
        const response = await this.transactionCodeGroupsClient.transactionCodeGroupsPost(
            group.toDto() as TransactionCodeGroupModelDto
        );
        return TransactionCodeGroup.from(response.data);
    }

    public async updateTransactionCodeGroup(
        id: number,
        group: TransactionCodeGroup
    ): Promise<TransactionCodeGroup> {
        const response = await this.transactionCodeGroupsClient.transactionCodeGroupsPut(
            id,
            group.toDto() as TransactionCodeGroupModelDto
        );
        return TransactionCodeGroup.from(response.data);
    }

    public async deleteTransactionCodeGroup(id: number): Promise<void> {
        await this.transactionCodeGroupsClient.transactionCodeGroupsDelete(id);
    }
}
